import socketIOClient from 'socket.io-client'
import sailsIOClient from 'sails.io.js'

let io = sailsIOClient(socketIOClient)
io.sails.autoConnect = false
// io.sails.url = process.env.apiUrl

const sailsPlugin = { }

sailsPlugin.install = function (Vue, options) {
  Vue.sailsConnect = function (token) {
    this.io.sails.headers = { 'x-token': token }
    this.io.socket = this.io.sails.connect(process.env.VUE_APP_API_URL, { headers: { 'x-token': token } })
    return true
  }
  Vue.io = io
}

export default sailsPlugin



// WEBPACK FOOTER //
// ./src/plugins/sails.js